import * as React from 'react';
import { Col } from 'reactstrap';
import { IImageStatusType, IAgency } from '../../../../../share/types/agency';
import ImageDropZone from 'src/share/components/ImageDropZone/ImageDropZone';

export interface ILogoDropZoneProps {
  setValue: (path: string, value: any) => void;
  logoSelected: boolean;
  imageUploadingStatus: IImageStatusType;
  agencyInfo: IAgency;
  loading: boolean;
}

export class LogoDropZone extends React.Component<ILogoDropZoneProps, any> {
  constructor(props: ILogoDropZoneProps) {
    super(props);
  }

  public render() {
    return (
      <Col md="12">
        <div className={'logo-agency-dropzone'} >
          <ImageDropZone
            {...this.imageHandler()}
          />
        </div>
      </Col>
    );
  }

  public imageHandler(logo: string = 'logo') {
    const { imageUploadingStatus, agencyInfo, loading, logoSelected } = this.props;
    const status = imageUploadingStatus && imageUploadingStatus[logo] && imageUploadingStatus[logo].status;

    return {
      onChange: (base64: string) => {
        this.props.setValue('agencyInfo.logo.url', base64);
        this.props.setValue('logoSelected', true);
      },
      loading,
      status,
      thumbnail: agencyInfo.logo.url || '',
      required: true,
      disabled: loading,
      labelText: 'Logo',
      className: `${!logoSelected ? ' validationField' : ''}`
    }
  }
}

export default LogoDropZone;
